import AuditListing from "./AuditListing";
export {
    AuditListing,
}
export const fisAuditFilters = {
    'action_type': {
        'inputType': 'dropdown',
        'title': 'Action Type',
        'options': [{ label: "SPARTA_TO_HANWHA", value: "1" }, { label: "HANWHA_TO_SPARTA", value: "2" }],
        'labelKey': 'label',
        'valueKey': 'label',
    },
    'status': {
        'inputType': 'dropdown',
        'title': 'Status',
        'options': [{ label: "SUCCESS", value: "1" }, { label: "FAILED", value: "2" }],
        'labelKey': 'label',
        'valueKey': 'label',
    },
}

export const auditListHd = [
    { id: 'action_type', label: 'Action Type', sortOption: true },
    { id: 'created_at', label: 'Date and Time', sortOption: true },
    { id: 'status', label: 'Status', sortOption: false },
    { id: 'folder_path', label: 'Folder Path', sortOption: false },
    { id: 'file_name', label: 'File Name', sortOption: false },
    { id: 'notified_emails', label: 'Notification', sortOption: false },
]
